import React from "react";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { Field } from "react-final-form";
import { DateFormFieldProps } from "../common/components/FormFields/DateFormField";
import { FormFieldWrapper } from "../common/components/FormFields/FormFieldWrapper";
import { calendarDate, validateCalendarDate } from "./otlDate";

export function OtlDateFormField({
  name,
  label,
  required,
  disabled,
  minDate,
  maxDate,
  stringOutput,
  size,
  ...wrapperProps
}: DateFormFieldProps) {
  return (
    <FormFieldWrapper {...wrapperProps}>
      <Field
        name={name}
        validate={(value) => {
          const error = validateCalendarDate(value, required);
          if (error || !value) return error;
          if (minDate && dayjs(value).isBefore(minDate, "day"))
            return "Date is before the earliest allowed date";
          if (maxDate && dayjs(value).isAfter(maxDate, "day"))
            return "Date is after the latest allowed date";
          return undefined;
        }}
      >
        {({ input: { onChange, value, ...input }, meta }) => {
          const error =
            (meta.touched || meta.submitFailed) &&
            (meta.error || (!meta.dirtySinceLastSubmit && meta.submitError));
          return (
            <DatePicker
              label={label}
              disabled={disabled}
              format="DD/MM/YYYY"
              minDate={minDate}
              maxDate={maxDate}
              value={value ? dayjs(value) : null}
              onChange={(date: Dayjs | null) => onChange(calendarDate(date))}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size,
                  required,
                  disabled,
                  inputProps: input,
                  error: Boolean(error),
                  helperText: error,
                },
              }}
            />
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
}
